import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable()
export class AddClientModalService {
  invite: any = null;
  newInvite = new Subject();

  constructor() {}
}
